import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ListDaftarCuti from "../components/ListDaftarCuti";
import CutiContain from "./CutiContain";
import ListDaftarProsesCuti from "../components/ListDaftarProsesCuti";
import ListRekapCuti from "../components/ListRekapCuti";
import TahunFilterComponent from "../components/TahunFilterComponent";
import { SearchBar } from "../../../CommonElements";
import { Col, Row } from "reactstrap";
import { useCuti } from "../../../Context/CutiContext";
import { useStaf } from "../../../Context/StafContext";
import { useAbsensi } from "../../../Context/AbsensiContext";

const DaftarCuti = () => {
  const cutiAPI = useCuti();
  const stafAPI = useStaf();
  const absensiAPI = useAbsensi();  
  const { search } = useLocation();
  const parameters = new URLSearchParams(search);
  const type = parameters.get("type");

  const [data, setData] = useState({
    cuti: [],
    staf: [],
    groupStaf: [],
    tipeAbsensi: [],
  });

  const [pending, setPending] = useState({ cuti: false, staf: false });
  const [tahunFilter, setTahunFilter] = useState(new Date().getFullYear());
  const [searchFilter, setSearchFilter] = useState("");

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      refreshDaftarCuti();
      refreshDaftarStaf();
      refreshDaftarGroupStaf();
      refreshDaftarTipeAbsensi();
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    refreshDaftarCuti();
  }, [tahunFilter]);

  const refreshDaftarCuti = async () => {
    setPending((prev) => ({ ...prev, cuti: true }));
    cutiAPI.getCutiByYear(tahunFilter)
      .then((res) => {
        setData((prev) => ({ ...prev, cuti: res.data }));
      })
      .finally(() => setPending((prev) => ({ ...prev, cuti: false })));
  };
  const refreshDaftarStaf = async () => {
    setPending((prev) => ({ ...prev, staf: true }));
    stafAPI.getStaf()
      .then((res) => {
        setData((prev) => ({ ...prev, staf: res.data }));
      })
      .finally(() => setPending((prev) => ({ ...prev, staf: false })));
  };
  const refreshDaftarGroupStaf = async () => {
    stafAPI.getGroupStaf().then((res) => {
      setData((prev) => ({ ...prev, groupStaf: res.data }));
    });
  };
  const refreshDaftarTipeAbsensi = async () => {
    absensiAPI.getTipeAbsensi().then((res) => {
      setData((prev) => ({ ...prev, tipeAbsensi: res.data }));
    });
  };

  const updateTahunFilter = (newYear) => {
    setTahunFilter(parseInt(newYear));
  };

  const getSubHeaderComponent = () => {
    return (
      <Col>
        <Row>
          <Col>
            <TahunFilterComponent updateTahunFilter={updateTahunFilter} />
          </Col>
          <Col>
            <SearchBar onChange={(e) => setSearchFilter(e.target.value)} />
          </Col>
        </Row>
      </Col>
    );
  };

  return (
    <CutiContain
      title={
        type === "rekap"
          ? "Cuti"
          : type === "proses"
          ? "Daftar Dalam Proses Cuti"
          : "Daftar Cuti Disetujui"
      }
      subtitle={type === "rekap" && "Daftar Cuti"}
      refreshDaftarCuti={refreshDaftarCuti}
      selectedComponent={type}
    >
      {type === "rekap" ? (
        <ListRekapCuti
          data={data}
          pending={pending.staf}
          resetState={refreshDaftarCuti}
          searchFilter={searchFilter}
          getSubHeaderComponent={getSubHeaderComponent}
        />
      ) : type === "proses" ? (
        <ListDaftarProsesCuti
          data={data}
          pending={pending?.cuti}
          resetState={refreshDaftarCuti}
          searchFilter={searchFilter}
          getSubHeaderComponent={getSubHeaderComponent}
        />
      ) : (
        <ListDaftarCuti
          data={data}
          pending={pending?.cuti}
          resetState={refreshDaftarCuti}
          searchFilter={searchFilter}
          getSubHeaderComponent={getSubHeaderComponent}
        />
      )}
    </CutiContain>
  );
};

export default DaftarCuti;
